// src/components/Badge.tsx
import { cn } from '../lib/utils';

interface BadgeProps {
  status: 'active' | 'archived' | 'completed' | string;
  className?: string;
}

export function Badge({ status, className }: BadgeProps) {
  // Using the refined colors from your ProjectView component
  const styles: Record<string, string> = {
    active: 'bg-emerald-50 text-emerald-700 border-emerald-100',
    archived: 'bg-slate-100 text-slate-600 border-slate-200',
    completed: 'bg-brand-blue/10 text-brand-blue border-brand-blue/20',
  };

  return (
    <span className={cn(
      'text-[10px] uppercase tracking-wider font-bold px-2.5 py-1 rounded-full border shadow-sm',
      styles[status] ?? styles.active,
      className
    )}>
      {status}
    </span>
  );
}